import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginModel {

  private username: string = "";
  private password: string = "";

  constructor() { }

  setUsername(username: string) {
    this.username = username;
  }

  getUsername(): string {
    return this.username;
  }

  setPassword(password: string) {
    this.password = password;
  }

  getPassword(): string {
    return this.password;
  }

  toString() {
    return JSON.stringify({
      username: this.getUsername(),
      password: this.getPassword()
    });
  }

}
